export class ActivityType {
  id: string;
  name: string;
}
